module.exports = "<div class=c-email> <div class=c-email__wrapper> <div ng-bind-html=$ctrl.loadContent()></div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./frontend/admin/app/modules/order/views/email.content.html
// module id = 908
// module chunks = 0